import * as INTERESTS_TYPES from "./store/types";

export const INTERESTS = {
  1: INTERESTS_TYPES.FASHION,
  2: INTERESTS_TYPES.TRAVEL,
  3: INTERESTS_TYPES.HEALTH_AND_FITNESS,
  4: INTERESTS_TYPES.BEAUTY_AND_MAKEUP,
  5: INTERESTS_TYPES.NEWS_AND_POLITICS,
  6: INTERESTS_TYPES.MUSIC,
  7: INTERESTS_TYPES.HOME_AND_LIFESTYLE,
  8: INTERESTS_TYPES.PETS_AND_ANIMALS,
  9: INTERESTS_TYPES.ART_AND_ARCHITECTURE,
  10: INTERESTS_TYPES.SPORTS,
  11: INTERESTS_TYPES.COMICS_AND_ANIME,
  12: INTERESTS_TYPES.GAMING,
  13: INTERESTS_TYPES.AUTOS,
  14: INTERESTS_TYPES.SCIENCE,
  15: INTERESTS_TYPES.COMEDY_AND_FUN,
  16: INTERESTS_TYPES.PARENTING,
  17: INTERESTS_TYPES.FOOD_AND_DRINK,
  18: INTERESTS_TYPES.PHOTOGRAPHY,
  19: INTERESTS_TYPES.HISTORY,
  20: INTERESTS_TYPES.ASTRONOMY,
  21: INTERESTS_TYPES.EDUCATION,
  22: INTERESTS_TYPES.BUISNESS,
  23: INTERESTS_TYPES.TECHNOLOGY,
  24: INTERESTS_TYPES.MOVIES,
  25: INTERESTS_TYPES.BOOKS_AND_LITERATURE,
  26: INTERESTS_TYPES.RELIGION,
};
